import Link from 'next/link';
import type { NavLink } from './type';

export function MobileSubmenuLink({ label, href }: NavLink) {
  return (
    <li className="text-[32px] leading-[120%] tracking-[-0.96px] px-4 py-6">
      <Link href={href || '#'} prefetch={false} className="flex items-center justify-between">
        <span>{label}</span>
      </Link>
    </li>
  );
}
